import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import {
  setCurrentCampus, setCurrentSemesterCode,
} from '../../../store/auth.slice';
import { doGetSemesters, getSemestersSuccess } from '../../../store/semester.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import qs from 'qs';
import { useSnackbar } from 'notistack';
import { Select } from 'antd';
import Button from '../../Button';
import { warningVariant, errorVariant } from '../../../lib/barVariant';
import { IGetCurrentSemester, ISemester } from '../../../models/semesters.model';
import Loader from '../../Loader';
import SelectCampus from '../../SelectCampus';
import useNotification from '../../../hooks/useNotification';
import Checkbox from '../../Checkbox';
import SelectEduStep from '../../SelectEduStep';
import { SEMESTER_TYPE } from '../../../constans';
import YearSelect from '../../common/YearSelect';
import SemesterTypeSelect from '../../common/SemesterTypeSelect';
import useFirstConditionEffect from '../../../hooks/useFirstConditionEffect';
import useAxios from '../../../hooks/useAxios';
import { getCurrentSemester } from '../../../api/semesters.api';

const { Option } = Select;

interface IProps {
  tab: string;
}

const ClassSearch: FC<IProps> = ({
  tab,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const dispatch = useDispatch();
  const { infoNotification } = useNotification();
  const { currentCampus, currentSemesterCode } = useSelector(
    (state: RootState) => state.auth,
  );
  const { semesters, isLoading } = useSelector(
    (state: RootState) => state.semester,
  );

  const { data: resCurrentSemester, isLoading: isLoading2, execute: execCurrentSemester } = useAxios<IGetCurrentSemester>();

  // 상수
  const OPTION_VALUE_ALL = 'all';

  // 상태
  const [eduStepCode, setEduStepCode] = useState('');
  const [keyword, setKeyword] = useState('');
  const [includeClosed, setIncludeClosed] = useState(false);
  const [semesterType, setSemesterType] = useState(OPTION_VALUE_ALL);
  const [semesterCode, setSemesterCode] = useState<number | undefined>(undefined);
  const [year, setYear] = useState(OPTION_VALUE_ALL);

  const filterSemesters = (semesters: ISemester[] | undefined, year: string, semesterType: string) => {
    if (!semesters) return [];

    return semesters.filter(s => {
      const conditions = [
        year === OPTION_VALUE_ALL || s.learningYearCode === year,
        semesterType === OPTION_VALUE_ALL || s.semesterType === semesterType
      ]
      return conditions.every(Boolean);
    });
  };

  const filteredSemesters = useMemo(() => filterSemesters(semesters, year, semesterType), [semesters, year, semesterType]);

  /*
  const validSemesterCode = useMemo(() => {
    if (filteredSemesters.length === 0) return undefined;
    const found = filteredSemesters.find((s) => s.semesterCode === semesterCode);
    return found ? semesterCode : filteredSemesters[0].semesterCode;
  }, [filteredSemesters, semesterCode]);

  useEffect(() => {
    setSemesterCode(validSemesterCode);
  }, [validSemesterCode]);
  */

  useEffect(() => {
    getSemesters();

    let semesterCodeChk: boolean = false;
    const semesterCode = localStorage.getItem('semesterCode');
    if (semesterCode) {
      const _semesterCode = Number(semesterCode);
      const semester = semesters?.find(
        (item) => item.semesterCode === _semesterCode,
      );
      if (semester) {
        setSemesterCode(_semesterCode);
        semesterCodeChk = true;
      }
    }

    if (Object.keys(query).length > 0) {
      if (query.campus) {
        dispatch(setCurrentCampus(String(query.campus)));
      }
      if (query.semester) {
        localStorage.setItem('semesterCode', String(query.semester));
        setSemesterCode(Number(query.semester));
        semesterCodeChk = true;
      }
      if (query.keyword) {
        setKeyword(String(query.keyword));
      }
    }

    if(!semesterCodeChk) {
      execCurrentSemester(getCurrentSemester());
    }
  }, []);

   useEffect(() => {
      if (resCurrentSemester && !isLoading2) {
        if (resCurrentSemester?.data?.semesterCode) {
          setSemesterCode(resCurrentSemester.data.semesterCode);
        } else {
          setSemesterCode(undefined);
        }
      }
  }, [resCurrentSemester, isLoading2]);

  useFirstConditionEffect(!!semesterCode, () => {
    onSearch();
  })

  const getSemesters = async () => {
    const res = await dispatch(doGetSemesters());

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(
          res?.data?.data || t('common.message.error'),
          errorVariant,
        );
    }
  };

  const onSearch = () => {
    if (!semesterCode) {
      return infoNotification(t('statistics.dttt.message1'));
    }

    const param: any = {
      ...query,
      page: 1,
      tab,
      campus: currentCampus,
      semesterType,
      semester: semesterCode,
    };

    if (eduStepCode) {
      param.eduStepCode = eduStepCode;
    } else {
      delete param.eduStepCode;
    }
    if (keyword) {
      param.keyword = keyword;
    } else {
      delete param.keyword;
    }
    if (includeClosed) {
      param.includeClosed = true;
    } else {
      delete param.includeClosed;
    }

    history.push(`/class/class2?${qs.stringify(param)}`);
  };

  const semesterCodeStorageSet = (semesterCode : number) => {
    setSemesterCode(semesterCode);
    localStorage.setItem('semesterCode', String(semesterCode));
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label>
              <div>
                <SelectCampus />
              </div>
            </li>
            <li>
              <label>{t('common.text.year')}</label>
              <div>
                <li>
                  <YearSelect
                    year={year}
                    setYear={setYear}
                    hasAllOption
                  />
                </li>
              </div>
            </li>
            <li>
              <label>{t('common.semester.type')}</label>
              <div>
                <li>
                  <SemesterTypeSelect
                    semesterType={semesterType}
                    setSemesterType={setSemesterType}
                    hasAllOption
                  />
                </li>
              </div>
            </li>
            <li>
              <label>{t('class.class.placeholder4')}</label>
              <div className='w-150p'>
                <Select
                  placeholder={t('class.class.placeholder4')}
                  value={semesterCode}
                  onChange={(value) => {
                    //setSemesterCode(value);
                    semesterCodeStorageSet(value);
                  }}
                  className='w-100'
                >
                  {filteredSemesters.map((item: ISemester) => (
                    <Option
                      key={item.semesterCode}
                      value={item.semesterCode || ''}
                    >
                      {item.semesterName}
                    </Option>
                  ))}
                </Select>
              </div>
            </li>
            <li>
              <label>{t('common.placeholder.1')}</label>
              <div>
                <SelectEduStep
                  eduStepCode={eduStepCode}
                  setEduStepCode={setEduStepCode}
                  includeAll
                  fullWidth
                />
              </div>
            </li>
            <li>
              <label>{t('class.class.placeholder3')}</label>
              <input
                type="text"
                className="form-control w-150p"
                placeholder={t('class.class.placeholder3')}
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') onSearch();
                }}
              />
              <Checkbox
                checked={includeClosed}
                onChange={() => setIncludeClosed(!includeClosed)}
                text={t('class.class.option1')}
              />
              <div className='comm-btn__area'>
                <Button
                  className="btn-basic small black"
                  onClick={() => onSearch()}
                  text={t('common.button.search')}
                />
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default ClassSearch;
